import { supabase } from '@/lib/supabase/supabaseClient'
import { getUrl } from '../utils'

export const signIn = async (email: string, password: string) => {
    return await supabase.auth.signInWithPassword({
        email: email,
        password: password,
    })
}

export const signUp = async (email: string, password: string, first_name: string, last_name: string) => {
    return await supabase.auth.signUp({
        email: email,
        password: password,
        options: {
            data: {
                first_name,
                last_name,
            },
            emailRedirectTo: getUrl(),
        },
    })
}

export const logOut = async () => {
    return await supabase.auth.signOut()
}

export const getUserData = async (id: string) => {
    return await supabase.from('user').select('*').eq('id', id)
}

export const getUserSession = async () => {
    const res = await supabase.auth.getSession()
    // console.log(res)
    return res; 
}

export const setupAccount = async ({
    first_name,
    last_name,
    password,
} : {
    password: string, 
    first_name: string,
    last_name: string
}) => {
    return await supabase.auth.updateUser({ 
        password, 
        data: {
            first_name,
            last_name
        }
    });
}

export const updateUserData = async ({id, first_name, last_name} : {id: string, first_name: string, last_name: string}) => {
    return await supabase.from('user').update({
        first_name,
        last_name
    }).eq("id", id);
}
